import React from "react";
import { useTablesStyle } from "../../../styles/tableStyle";
import {
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails,
  TableRow,
  TableCell,
  IconButton,
  Avatar,
  Typography,
  withStyles,
  Box,
  Collapse,
} from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import OrderDetails from "../orderDetails/OrderDetails";
import { connect } from "react-redux";

import OrderDetailTable from "../orderDetails/OrderDetailTable";
import QrCode from "../../../components/QrCode";

const Row = (props) => {
  const { row, page, perPage, set_current_row, current_row } = props;

  const classes = useTablesStyle();

  return (
    perPage > 0 ? row.slice(page * perPage, page * perPage + perPage) : row
  ).map((row, index) => {
    return (
      <React.Fragment key={index}>
        <TableRow
          className={classes.TableRow}
          style={{ borderBottom: "unset" }}
        >
          <TableCell className={classes.TableCell} width="15%">
            <OrderDetails
              orderId={row.id}
              rowValue={row.number}
              position="number"
            />
          </TableCell>
          <TableCell className={classes.TableCell} width="10%">
            <Typography variant="subtitle2" color="textSecondary">
              {Number(row.price).toLocaleString()}
            </Typography>
          </TableCell>
          <TableCell className={classes.TableCell} width="15%">
            <Avatar variant="circular" className={classes.Avatar}>
              {row.qtty}
            </Avatar>
          </TableCell>
          <TableCell
            className={classes.TableCell}
            style={{ flexDirection: "column" }}
            width="15%"
          >
            <Typography color="textSecondary" variant="subtitle2">
              {row.order_date}
            </Typography>

            <Typography color="textSecondary" variant="subtitle2">
              {row.order_time}
            </Typography>
          </TableCell>
          <TableCell
            className={classes.TableCell}
            style={{ flexDirection: "column" }}
            width="15%"
          >
            <Typography color="textSecondary" variant="subtitle2">
              {row.delivery_date}
            </Typography>
            <Typography color="textSecondary" variant="subtitle2">
              {row.delivery_start_time + " "}-{" " + row.delivery_end_time}
            </Typography>
          </TableCell>
          <TableCell className={classes.TableCell} width="10%">
            <QrCode icon={true} orderId={row.id} />
          </TableCell>
          <TableCell className={classes.TableCell} width="10%">
            <IconButton
              color="primary"
              size="small"
              onClick={() => {
                set_current_row((pre) => {
                  if (pre === row.id) {
                    return "";
                  } else {
                    return row.id;
                  }
                });
              }}
            >
              {current_row === row.id ? (
                <KeyboardArrowUp />
              ) : (
                <KeyboardArrowDown />
              )}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow
          style={{ backgroundColor: "lightblue" }}
          className={classes.TableRow}
        >
          <TableCell
            style={{
              paddingBottom: 0,
              paddingTop: 0,
              width: "100%",
            }}
            colSpan={12}
          >
            <Collapse
              in={current_row === row.id}
              mountOnEnter
              unmountOnExit
              style={{ width: "100%", margin: "auto" }}
            >
              <Box style={{ margin: "16px 0", width: "100%" }}>
                <OrderDetailTable
                  orderId={row.id}
                  rowValue={row.number}
                  history={true}
                />
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  });
};
const mapStateToProps = (props) => {
  const { OrderReducer, historyReducer } = props;
  const { subOrders } = OrderReducer;
  const { page, perPage } = historyReducer;

  return { subOrders, page, perPage };
};

export default connect(mapStateToProps)(Row);
export const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

export const AccordionSummary = withStyles({
  root: {
    backgroundColor: "white",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

export const AccordionDetails = withStyles((theme) => ({
  root: {
    margin: "16px",
    padding: theme.spacing(5),
  },
}))(MuiAccordionDetails);
